module.exports = __webpack_public_path__ + "img/1corelogo.09c5f67d.png";